export class profile{
    firstName:any;
    lastName:any;
    mobileNumber:any;
    emailId:any;
    roleId:any;
    passWord:any;
    profilePhoto:any;
    id:any
    _id:any
    role_name:any;
    status:any
}